import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';
import { awardsApiRef } from './api/types';
import { AwardsBackendApi } from './api/AwardsBackendClient';

// ── API (→ global API registry) ─────────────────────────
const awardsApi = ApiBlueprint.make({
  name: 'awards-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: awardsApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, fetchApi }) =>
          new AwardsBackendApi({ discoveryApi, fetchApi }),
      }),
    ),
});

// ── Route (→ app/routes) ────────────────────────────────
const awardsPage = PageBlueprint.make({
  params: {
    path: '/awards',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/AwardsRouter').then(m => <m.Neo4jAwardsRouter />),
  },
});

export default createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  pluginId: 'neo4j-awards',
  extensions: [awardsApi, awardsPage],
  routes: {
    root: rootRouteRef,
  },
});
